import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Listing, PrimeProperties } from 'src/app/shared/models';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor(private http: HttpClient) {}

  getAddedTodayProperties() {
    return this.http.get<Listing[]>(
      environment.baseUrl + 'Home/GetAddedTodayProperties'
    );
  }

  getArisPrimeProperties() {
    return this.http.get<Listing[]>(
      environment.baseUrl + 'Home/GetArisPrimeProperties'
    );
  }

  getRecommendedProperties() {
    return this.http.get<Listing[]>(
      environment.baseUrl + 'Home/GetRecommendedProperties'
    );
  }
}
